import LieuxController from './lieux.controller';

export default {
    template: require('./lieux.tpl.html'),
    controller: LieuxController
};
